// API URLs - loaded from .env via Vite

// App version
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0'

// Production API
export const API_URL = import.meta.env.VITE_API_URL || 'https://coin.grotekeizer.nl/api/v1'

// Pusher/Reverb config
export const REVERB_APP_CLUSTER = import.meta.env.VITE_REVERB_APP_CLUSTER || 'eu'
export const REVERB_AUTH_URL = import.meta.env.VITE_REVERB_AUTH_URL || 'https://coin.grotekeizer.nl/employee/broadcasting/auth'
export const REVERB_KEY = import.meta.env.VITE_REVERB_KEY || 'hajqb9bewpecls71tmq0h'
export const REVERB_HOST = import.meta.env.VITE_REVERB_HOST || 'coin.grotekeizer.nl'
export const REVERB_PORT = Number(import.meta.env.VITE_REVERB_PORT) || 443
export const REVERB_SCHEME = import.meta.env.VITE_REVERB_SCHEME || 'https'

// Deep link scheme for Smartpin
export const DEEP_LINK_SCHEME = import.meta.env.VITE_DEEP_LINK_SCHEME || 'pos-terminal://'

// Legacy exports for backward compatibility (matching RN naming)
export const EXPO_PUBLIC_API_URL = API_URL
export const EXPO_PUBLIC_REVERB_APP_CLUSTER = REVERB_APP_CLUSTER
export const EXPO_PUBLIC_REVERB_AUTH_URL = REVERB_AUTH_URL
export const EXPO_PUBLIC_REVERB_KEY = REVERB_KEY
export const EXPO_PUBLIC_REVERB_HOST = REVERB_HOST
export const EXPO_PUBLIC_REVERB_PORT = REVERB_PORT
export const EXPO_PUBLIC_REVERB_SCHEME = REVERB_SCHEME
export const EXPO_PUBLIC_APP_VERSION = APP_VERSION